import { useMutation, useQueryClient } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'

export const useRetryImageAnalysis = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (imageId: number) => aiStudioService.retryImageAnalysis(imageId),
    onSuccess: (data, imageId) => {
      // 이미지 정보 쿼리를 무효화하여 재폴링 시작
      queryClient.invalidateQueries({
        queryKey: ['image-info', imageId],
      })
    },
    onError: (error) => {
      console.error('이미지 분석 재시도 실패:', error)
    },
  })
}